import { H1 } from '@betterment/samba-react';

import CommonReports from './common-reports/CommonReports';
import { GeneratedReports } from './generated-reports-table/GeneratedReports';
import { Notifications } from './reports-notifications/Notifications';

import { ApplicationLayout } from '../layout/ApplicationLayout';

/**
 * Reports page component for the SPA.
 * Renders the main reports interface with notifications, common reports, and generated reports table.
 */
export const ReportsPage = () => {
  return (
    <ApplicationLayout pageTitle="Reports">
      <ApplicationLayout.Header>
        <H1 variant="pageTitle">Reports</H1>
      </ApplicationLayout.Header>
      <ApplicationLayout.Content>
        <Notifications />
        <CommonReports />
        <GeneratedReports />
      </ApplicationLayout.Content>
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
